import {

    FETCHING_REQUEST, 
    FETCHING_SUCCESS, 
    FETCHING_FAILURE,
    SENDING_REQUEST, 
    SENDING_SUCCESS, 
    SENDING_FAILURE,
    CALCULATING_REQUEST, 
    CALCULATING_SUCCESS, 
    CALCULATING_FAILURE,
    FETCHING_DETAILS_REQUEST, 
    FETCHING_DETAILS_SUCCESS, 
    FETCHING_DETAILS_FAILURE,
    SENDING_TOSF_REQUEST, 
    SENDING_TOSF_SUCCESS, 
    SENDING_TOSF_FAILURE

} from 'actions/emails';

export default (state = {
  isFetching: false,
  isCalculating: false,
  isSending: false,
  isSent: false,
  previewData: {},
  isSFFetching: false,
  isSFSending: false,
  isSFSent: false,  
  sfListing: {},

}, action) => {
  switch (action.type) {
    case FETCHING_REQUEST:
      return {
        ...state,
        isFetching: true,
        isSent: false
      }
    case FETCHING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        previewData: action.response,
        error: undefined
      }
    case FETCHING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      }
    case CALCULATING_REQUEST:
      return {
        ...state,
        isCalculating: true,
        isSent: false
      }
    case CALCULATING_SUCCESS:
      return {
        ...state,
        isCalculating: false,
        previewData: action.response,
        error: undefined
      }
    case CALCULATING_FAILURE:
      return {
        ...state,
        isCalculating: false,
        error: action.error
      }
    case SENDING_REQUEST:
      return {
        ...state,
        isSending: true,
        isSent: false
      }
    case SENDING_SUCCESS:
      return {
        ...state,
        isSending: false,
        isSent: action.response,
        error: undefined
      }
    case SENDING_FAILURE:
      return {
        ...state,
        isSending: false,
        error: action.error
      }
    case FETCHING_DETAILS_REQUEST:
      return {
        ...state,
        isSFFetching: true,
      }
    case FETCHING_DETAILS_SUCCESS:
      return {
        ...state,
        isSFFetching: false,
        sfListing: action.response,
        error: undefined
      }
    case FETCHING_DETAILS_FAILURE:
      return {
        ...state,
        isSFFetching: false,
        error: action.error
      }    
    case SENDING_TOSF_REQUEST:
      return {
        ...state,
        isSFSending: true,
        isSFSent: false
      }
    case SENDING_TOSF_SUCCESS:
      return {
        ...state,
        isSFSending: false,
        isSFSent: action.response,
        sfListing: {},
        error: undefined
      }
    case SENDING_TOSF_FAILURE:
      return {
        ...state,
        isSFSending: false,
        sfListing: {},
        error: action.error
      }

    default:
      return state;
  }
}
